export const seriesId = [
  "pib_spain_dollar_1990gk",
  "pib_france_dollar_1990gk",
  "pib_uk_dollar_1990gk",
  "pib_usa_dollar_1990gk",
  "pib_spain_dollar_2021gk",
  "pib_france_dollar_2021gk",
  "pib_uk_dollar_2021gk",
  "pib_usa_dollar_2021gk",
]

export const seriesEsp = [
  "PIB per cápita España(dólares Geary-Khamis de 1990)",
  "PIB per cápita Francia(dólares Geary-Khamis de 1990)",
  "PIB per cápita Reino Unido(dólares Geary-Khamis de 1990)",
  "PIB per cápita Estados Unidos(dólares Geary-Khamis de 1990)",
  "PIB per cápita España(dólares GEKS de 2021)",
  "PIB per cápita Francia(dólares GEKS de 2021)",
  "PIB per cápita Reino Unido(dólares GEKS de 2021)",
  "PIB per cápita Estados Unidos(dólares GEKS de 2021)",
]

export const seriesEng = [
  "GDP per Capita Spain(Geary-Khamis dollars 1990)",
  "GDP per Capita France(Geary-Khamis dollars 1990)",
  "GDP per Capita United Kingdom(Geary-Khamis dollars 1990)",
  "GDP per Capita United States of America(Geary-Khamis dollars 1990)",
  "GDP per Capita Spain(GEKS dollars 2021)",
  "GDP per Capita France(GEKS dollars 2021)",
  "GDP per Capita United Kingdom(GEKS dollars 2021)",
  "GDP per Capita United States of America(GEKS dollars 2021)",
]
